import { all, fork } from "redux-saga/effects";

import * as authenticationSaga from "../../modules/publicPages/Login/apis/sagas";


export default function* rootSaga() {
  yield all(
    [
      ...Object.values(authenticationSaga),

    ].map(fork)
  );
}
